import * as d3 from 'd3'

export default (data) => {

    const width = 600;
    const height = 600;
    const radius = Math.min(width, height) / 2 - 80;
    const centerX = width / 2;
    const centerY = height / 2;

    const svg = d3.select("#spider-chart")
            .attr("width", width)
            .attr("height", height)
            .attr('viewBox', `0 0 ${width} ${height}`)

    const g = svg.append("g")
        .attr("transform", `translate(${centerX}, ${centerY})`);

    const axes = [
        { label: "0",  key: "no sharps/flats", angle: 0 },
        { label: "1♯", key: "1 ♯ sharp", angle: 1 * Math.PI / 6.5 },
        { label: "2♯", key: "2 ♯ sharps", angle: 2 * Math.PI / 6.5 },
        { label: "3♯", key: "3 ♯ sharps", angle: 3 * Math.PI / 6.5 },
        { label: "4♯", key: "4 ♯ sharps", angle: 4 * Math.PI / 6.5 },
        { label: "5♯", key: "5 ♯ sharps", angle: 5 * Math.PI / 6.5 },
        { label: "6♯", key: "6 ♯ sharps", angle: 6 * Math.PI / 6.5 },
        { label: "6♭", key: "6 ♭ flats", angle: 7 * Math.PI / 6.5 },
        { label: "5♭", key: "5 ♭ flats", angle: 8 * Math.PI / 6.5 },
        { label: "4♭", key: "4 ♭ flats", angle: 9 * Math.PI / 6.5 },
        { label: "3♭", key: "3 ♭ flats", angle: 10 * Math.PI / 6.5 },
        { label: "2♭", key: "2 ♭ flats", angle: 11 * Math.PI / 6.5 },
        { label: "1♭", key: "1 ♭ flat", angle: 12 * Math.PI / 6.5 }
    ];

    const validAxes = axes;
        
     // Find max value for scaling and set minimum radius for 0 value
    const maxValue = Math.max(...Object.values(data));
    const minRadius = 0; // Set minimum radius to 20% of total radius
    const scale = d3.scaleLinear()
        .domain([0, maxValue])
        .range([minRadius, radius]);

    // Draw grid circles
    const gridLevels = 3;
    for (let i = 1; i <= gridLevels; i++) {
        const r = minRadius + ((radius - minRadius) / gridLevels) * i;
        g.append("circle")
            .attr("r", r)
            .attr("class", "grid-line");
        
        // Add grid labels
        g.append("text")
            .attr("x", 5)
            .attr("y", -r)
            .attr("class", "grid-label")
            .text(Math.round((maxValue / gridLevels) * i));
    }
    // Add inner circle at minimum radius
        g.append("circle")
            .attr("r", minRadius)
            .attr("class", "grid-line")
            .style("stroke-width", "2px");
        
        // Add label for minimum value
        // g.append("text")
        //     .attr("x", 5)
        //     .attr("y", -minRadius)
        //     .attr("class", "grid-label")
        //     .text("0");

        // Draw axes
        validAxes.forEach(axis => {
            const x = Math.cos(axis.angle - Math.PI / 2) * radius;
            const y = Math.sin(axis.angle - Math.PI / 2) * radius;
            
            g.append("line")
                .attr("x1", 0)
                .attr("y1", 0)
                .attr("x2", x)
                .attr("y2", y)
                .attr("class", "axis-line");
            
            // Add labels
            const labelX = Math.cos(axis.angle - Math.PI / 2) * (radius + 40);
            const labelY = Math.sin(axis.angle - Math.PI / 2) * (radius + 40);
            
            const labelClass = axis.key.includes('♯') ? 'axis-label sharp-label' : 
                              axis.key.includes('♭') ? 'axis-label flat-label' : 
                              'axis-label';
            
            g.append("text")
                .attr("x", labelX)
                .attr("y", labelY)
                .attr("class", labelClass)
                .style("text-anchor", "middle")
                .style("dominant-baseline", "middle")
                .text(axis.label);
        });

        // Create path for data
        const lineGenerator = d3.line()
            .x(d => d.x)
            .y(d => d.y)
            .curve(d3.curveLinearClosed);

        const pathData = validAxes.map(axis => {
            const value = data[axis.key] || 0;
            const r = scale(value);
            const x = Math.cos(axis.angle - Math.PI / 2) * r;
            const y = Math.sin(axis.angle - Math.PI / 2) * r;
            return { x, y, value };
        });

        // Draw data area
        g.append("path")
            .datum(pathData)
            .attr("d", lineGenerator)
            .attr("class", "data-line");

        // Draw data points
        g.selectAll(".data-point")
            .data(pathData)
            .enter()
            .append("circle")
            .attr("cx", d => d.x)
            .attr("cy", d => d.y)
            .attr("r", 5)
            .attr("class", "data-point");

        // Add value labels on data points
        // g.selectAll(".value-label")
        //     .data(pathData)
        //     .enter()
        //     .append("text")
        //     .attr("x", d => d.x)
        //     .attr("y", d => d.y - 10)
        //     .attr("class", "grid-label")
        //     .style("text-anchor", "middle")
        //     .style("font-weight", "bold")
        //     .text(d => d.value);
}